import Vue from "vue";
import VueRouter from "vue-router";
import login from "@/views/login.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "login",
    component: login,
  },

  {
    path: "/workbenches",
    name: "workbenches",
    component: () => import("../views/workbenches/workbenches.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/userInfo",
    name: "userInfo",
    component: () => import("../views/userInfo/userInfo.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/scancode",
    name: "scancode",
    component: () => import("../views/scancode/scancode.vue"),
    meta: { requiresAuth: true },
  },
  // 底部导航
  {
    path: "/tabbar",
    name: "tabbar",
    component: () => import("../views/tabbar/index.vue"),
    meta: { requiresAuth: true },
  },
  // 区域管理
  {
    path: "/regional",
    name: "regional",
    component: () => import("../views/regional/index.vue"),
    meta: { requiresAuth: true },
  },
  // 个体档案
  {
    path: "/individual",
    name: "individual",
    component: () => import("../views/individual/individual.vue"),
    meta: { requiresAuth: true },
  },
  // 批次详情
  {
    path: "/batchDetails",
    name: "batchDetails",
    component: () => import("../views/batchDetails/batch.vue"),
    meta: { requiresAuth: true },
  },
  // 用药报表
  {
    path: "/reportMedication",
    name: "reportMedication",
    component: () => import("../views/reportMedication/reportMedication.vue"),
    meta: { requiresAuth: true },
  },
  // 个人信息
  {
    path: "/dataPersonal",
    name: "dataPersonal",
    component: () => import("../views/dataPersonal/dataPersonal.vue"),
    meta: { requiresAuth: true },
  },
  // 修改密码
  {
    path: "/password",
    name: "password",
    component: () => import("../views/password/password.vue"),
    meta: { requiresAuth: true },
  },
  // 我的任务
  {
    path: "/mytask",
    name: "mytask",
    component: () => import("../views/mytask/mytask.vue"),
    meta: { requiresAuth: true },
  },
  // 历史任务
  {
    path: "/alltask",
    name: "alltask",
    component: () => import("../views/alltask/alltask.vue"),
    meta: { requiresAuth: true },
  },
  // 耳标扫码
  {
    path: "/earTag",
    name: "earTag",
    component: () => import("../views/earTag/earTag.vue"),
    meta: { requiresAuth: true },
  },
  // 用药上传
  {
    path: "/uploadMedication",
    name: "uploadMedication",
    component: () => import("../views/uploadMedication/uploadMedication.vue"),
    meta: { requiresAuth: true },
  },
  // 物品新增
  {
    path: "/additionItem",
    name: "additionItem",
    component: () => import("../views/additionItem/additionItem.vue"),
    meta: { requiresAuth: true },
  },
  // 库存列表
  {
    path: "/stockManagement",
    name: "stockManagement",
    component: () => import("../views/stockManagement/stockManagement.vue"),
    meta: { requiresAuth: true },
  },
  // 物品出库 物品入库
  {
    path: "/itemOutbound",
    name: "itemOutbound",
    component: () => import("../views/itemOutbound/itemOutbound.vue"),
    meta: { requiresAuth: true },
  },
  // 出库记录  入库记录
  {
    path: "/outboundRecord",
    name: "outboundRecord",
    component: () => import("../views/outboundRecord/outboundRecord.vue"),
    meta: { requiresAuth: true },
  },
  // 配种计划
  {
    path: "/breedingPlan",
    name: "breedingPlan",
    component: () => import("../views/breedingPlan/breedingPlan.vue"),
    meta: { requiresAuth: true },
  },
  // 配种管理
  {
    path: "/breedingManagement",
    name: "breedingManagement",
    component: () =>
      import("../views/breedingManagement/breedingManagement.vue"),
    meta: { requiresAuth: true },
  },
  // 配置上传
  {
    path: "/uploadConfiguration",
    name: "uploadConfiguration",
    component: () =>
      import("../views/uploadConfiguration/uploadConfiguration.vue"),
    meta: { requiresAuth: true },
  },
  // 生育管理
  {
    path: "/pregnancyManagement",
    name: "pregnancyManagement",
    component: () =>
      import("../views/pregnancyManagement/pregnancyManagement.vue"),
    meta: { requiresAuth: true },
  },
  // 生育记录
  {
    path: "/pregnancyRecord",
    name: "pregnancyRecord",
    component: () => import("../views/pregnancyRecord/pregnancyRecord.vue"),
    meta: { requiresAuth: true },
  },
  // 临产牲畜
  {
    path: "/birthPlan",
    name: "birthPlan",
    component: () => import("../views/birthPlan/birthPlan.vue"),
    meta: { requiresAuth: true },
  },
  // 防疫计划
  {
    path: "/epidemicPlan",
    name: "epidemicPlan",
    component: () => import("../views/epidemicPlan/epidemicPlan.vue"),
    meta: { requiresAuth: true },
  },

  // 日常计划
  {
    path: "/regularTask",
    name: "regularTask",
    component: () => import("../views/regularTask/regularTask.vue"),
    meta: { requiresAuth: true },
  },
  //称重上传
  {
    path: "/weighingInformation",
    name: "weighingInformation",
    component: () =>
      import("../views/weighingInformation/weighingInformation.vue"),
    meta: { requiresAuth: true },
  },
  // 称重上传
  {
    path: "/weightBlotooth",
    name: "weightBlotooth",
    component: () => import("../views/weightBlotooth/weightBlotooth.vue"),
    meta: { requiresAuth: true },
  },
  // 称重记录
  {
    path: "/weighingRecord",
    name: "weighingRecord",
    component: () => import("../views/weighingRecord/weighingRecord.vue"),
    meta: { requiresAuth: true },
  },
  // 喂料上传
  {
    path: "/feedingUpload",
    name: "feedingUpload",
    component: () => import("../views/feedingUpload/feedingUpload.vue"),
    meta: { requiresAuth: true },
  },
  // tmr
  {
    path: "/uploadTmr",
    name: "uploadTmr",
    component: () => import("../views/uploadTmr/index.vue"),
    meta: { requiresAuth: true },
  },
];
const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});
// 添加全局前置守卫
router.beforeEach((to, from, next) => {
  if (to.matched.some((record) => record.meta.requiresAuth)) {
    // 这里可以根据实际需求修改验证逻辑，例如检查 token 是否存在
    const isAuthenticated = localStorage.getItem("isAuthenticated"); // 假设认证状态存储在 localStorage 中
    const token = localStorage.getItem("token"); // 假设认证状态存储在 localStorage 中
    if (!token) {
      // 未认证，跳转到登录页面
      next("/");
      return;
    }
    if (!isAuthenticated) {
      // 未认证，跳转到登录页面
      next("/");
    } else {
      // 已认证，放行
      next();
    }
  } else {
    // 不需要认证的页面，直接放行
    next();
  }
});
export default router;
